'use client';

import type { HTMLAttributes } from 'react';
import type { MotionProps } from 'framer-motion';

import { m } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { useMediaQuery } from 'react-responsive';

import { varContainer } from './variants';

// ----------------------------------------------------------------------

export type MotionViewportProps = HTMLAttributes<HTMLDivElement> &
  MotionProps & {
    disableAnimate?: boolean;
    className?: string;
  };

export function MotionViewport({
  children,
  viewport,
  className,
  disableAnimate = true,
  ...other
}: MotionViewportProps) {
  const isSmallScreen = useMediaQuery({ maxWidth: 575 });

  const disabled = isSmallScreen && disableAnimate;

  if (disabled) {
    return (
      <div className={twMerge(className)} {...other}>
        {children}
      </div>
    );
  }

  return (
    <m.div
      initial="initial"
      whileInView="animate"
      variants={varContainer()}
      viewport={{ once: true, amount: 0.3, ...viewport }}
      className={twMerge(className)}
      {...other}
    >
      {children}
    </m.div>
  );
}
